module.exports = __webpack_public_path__ + "static/media/doda_burfi.5e484bcd.jpg";